import { Directive, ElementRef, HostListener, Input, NgModule } from '@angular/core';

type MaskToken = string | RegExp;

@Directive({
    standalone: true,
    selector: '[textMask]',
})
export class TextMaskDirective {
  @Input('textMask') config: { mask?: MaskToken[] } | null = null;
  private formatting = false;

  constructor(private readonly elementRef: ElementRef<HTMLInputElement>) {}

  @HostListener('input')
  onInput(): void {
    if (this.formatting || !this.config?.mask) {
      return;
    }

    const input = this.elementRef.nativeElement;
    const formatted = this.format(input.value, this.config.mask);

    if (formatted === input.value) {
      return;
    }

    this.formatting = true;
    input.value = formatted;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    this.formatting = false;
  }

  private format(value: string, mask: MaskToken[]): string {
    const chars = value.replace(/\W/g, '').split('');
    let charIndex = 0;

    return mask.reduce<string>((result, token) => {
      if (typeof token === 'string') {
        return charIndex < chars.length ? result + token : result;
      }

      while (charIndex < chars.length) {
        const char = chars[charIndex++];

        if (token.test(char)) {
          return result + char;
        }
      }

      return result;
    }, '');
  }
}

@NgModule({
    imports: [TextMaskDirective],
    exports: [TextMaskDirective],
})
export class TextMaskModule {}


